import { Injectable, Inject, Injector } from '@angular/core';
import { ListData } from '../components/items-list/list-data.service';
import {
    ItemsListElementType,
    ItemsListHeader,
    ItemsListHeaderProperties,
} from '../components/items-list/items-list-header';
import { SiteMapService } from './site-map.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';
import { ISiteMap } from '@fi-shared/models/site-map';

@Injectable()
export class SiteMapListDataService {
    constructor(
        private injector: Injector,
        private siteMapService: SiteMapService,
    ) {}

    getInstance(isLocalSort?: boolean) {
        return new SiteMapListData(this.injector, this.siteMapService, isLocalSort);
    }

    getContentInstance(isLocalSort?: boolean) {
        // todo
        //return new SiteMapContentListData(this.fiAppText, isLocalSort);
    }
}

export class SiteMapListData extends ListData<ISiteMap> {
    constructor(
        injector: Injector,
        private siteMapService: SiteMapService,
        isLocalSort?: boolean,
    ) {
        super(injector, isLocalSort);

        this.ObjectType = ObjectTypes.SiteMap;

        this.ShowDelete = this.ShowCheckBox = true;

        this.DeleteConfirmMessage = this.appTextService.get('sitemap.delete_permanently_confirm');
        this.DeleteMultipleConfirmMessage = this.appTextService.get('sitemap.delete_permanently_multiple_confirm');

        this.deleteFunc = (ids, items) => this.siteMapService.deleteSiteMapAction(ids, items);

        this.ShowFavoriteIcon = false;

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('common.name'),
                'Name',
                new ItemsListHeaderProperties('CcmListItem-Name', true, ItemsListElementType.A, {
                    Sref: function () {
                        return FiStateNames.SiteMap.View;
                    },
                    SrefParams: (data) => ({ Id: data.Id }),
                    //displayValueTemplateUrl: '/Utility/View/CcmList/CcmListItemDisplayValueWithChangedOn.html',
                    secondaryValue: (data) => {
                        return (
                            injector.get(FiFormatDateService).formatDate(data.ChangedOn, 'date') +
                            ' ' +
                            data.ChangedByUserName
                        );
                    },
                }),
            ),
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('tag.tag'),
                'TagName',
                new ItemsListHeaderProperties('CcmListItem-Name', true, ItemsListElementType.A, {
                    Sref: function () {
                        return FiStateNames.SiteMap.View;
                    },
                    SrefParams: (data) => ({ Id: data.Id }),
                }),
            ),
        );

        this.addChangedOnHeader();

        this.addCreatedByHeader();
    }
}
